import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root',
})
export class MenuService {

  isOpen = false;

  constructor() {
  }

  toggleMenu(): void {
    this.isOpen = !this.isOpen;
  }
}
